const salaryCalcFunction = (hours, hoursPrice, liters, litersPrice) => {
  return hours * hoursPrice + liters * litersPrice;
};

export default salaryCalcFunction;
